import script from "./VideoMore.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoMore.vue?vue&type=script&setup=true&lang=ts"

import "./VideoMore.vue?vue&type=style&index=0&id=49e99160&lang=scss&scoped=true"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49e99160"]])

export default __exports__